<template>
    <div class="forex-index">
        <page-navigate></page-navigate>

        <div class="forex-wrapper cn">
            <forexMenu />
            <div class="forex-wrapper-body">
                <section class="section1">
                    <h1 class="">交易计算器</h1>
                    <div class="tool-box">
                        <div class="tool-card">
                            <img src="../../assets/image/forex/tools/tool_icon1.svg" class="tool-card-icon" alt="" />
                            <a href="/forex-tools/pivot-points-calculator/" class="tool-card-title">枢轴点计算器</a>
                            <div class="pc">
                                <p class="tool-card-intro">
                                    此枢轴点计算器可在几秒钟内生成4种不同系统的枢轴点！帮您计算出多种枢轴点和支撑/阻力水平。
                                </p>
                            </div>
                            <div class="pc">
                                <a href="/forex-tools/pivot-points-calculator/" class="btn-line-red">立即查看</a>
                            </div>
                        </div>
                        <div class="tool-card">
                            <img src="../../assets/image/forex/tools/tool_icon2.svg" class="tool-card-icon" alt="" />
                            <a href="/forex-tools/fibonacci-calculator/" class="tool-card-title">斐波那契计算器</a>
                            <div class="pc">
                                <p class="tool-card-intro">
                                    斐波那契计算器可帮助您计算4种基本的斐波纳契回撤值。帮您计算已完结趋势的回撤水平。将改善您的外汇交易经历并可使您全时参与外汇市场。
                                </p>
                            </div>
                            <div class="pc">
                                <a href="/forex-tools/fibonacci-calculator/" class="btn-line-red">立即查看</a>
                            </div>
                        </div>
                        <div class="tool-card">
                            <img src="../../assets/image/forex/tools/tool_icon3.svg" class="tool-card-icon" alt="" />
                            <a href="/forex-tools/pip-value-calculator/" class="tool-card-title">点值计算器</a>
                            <div class="pc">
                                <p class="tool-card-intro">
                                    如果您想知道任何外汇交易货币的单个点的价格，请使用此点值计算器。在处理许多或异国货币对时，使用这个免费的外汇工具来计算和计划您的订单。您需要做的就是填写下面的表格，然后按“计算”按钮：
                                </p>
                            </div>
                            <div class="pc">
                                <a href="/forex-tools/pip-value-calculator/" class="btn-line-red">立即查看</a>
                            </div>
                        </div>
                        <div class="tool-card">
                            <img src="../../assets/image/forex/tools/tool_icon4.svg" class="tool-card-icon" alt="" />
                            <a href="/forex-tools/position-size-calculator/" class="tool-card-title">头寸规模计算器</a>
                            <div class="pc">
                                <p class="tool-card-intro">
                                    一个免费的外汇工具，可让您以单位和手数计算头寸大小，以准确管理您的风险。它适用于所有主要货币对和交叉盘。它只需要很少的输入值，但允许您根据您的特定需求对其进行微调。您需要做的就是填写下面的表格，然后按“计算”按钮）
                                </p>
                            </div>
                            <div class="pc">
                                <a href="/forex-tools/position-size-calculator/" class="btn-line-red">立即查看</a>
                            </div>
                        </div>
                        <div class="tool-card">
                            <img src="../../assets/image/forex/tools/tool_icon5.svg" class="tool-card-icon" alt="" />
                            <a href="/forex-tools/risk-reward-calculator/" class="tool-card-title">风险和收益计算器</a>
                            <div class="pc">
                                <p class="tool-card-intro">
                                    风险回报计算器可帮您计算出基于局部峰值和底部的斐波纳契回撤的头寸的最佳目标和各自的风险回报比率。这是一种进场前计算潜在风险的高效的工具。
                                </p>
                            </div>
                            <div class="pc">
                                <a href="/forex-tools/risk-reward-calculator/" class="btn-line-red">立即查看</a>
                            </div>
                        </div>
                        <div class="tool-card">
                            <img src="../../assets/image/forex/tools/tool_icon6.svg" class="tool-card-icon" alt="" />
                            <a href="/forex-tools/gain-loss-percentage-calculator/"
                                class="tool-card-title">损益百分比计算器</a>
                            <div class="pc">
                                <p class="tool-card-intro">
                                    此在线损益百分比计算器可快速告诉您您赢或输的帐户余额百分比。它还估计了再次达到盈亏平衡点所需的当前余额的百分比。或者，您可以输入百分比并查看货币收益或损失的大小。
                                </p>
                            </div>
                            <div class="pc">
                                <a href="/forex-tools/gain-loss-percentage-calculator/"
                                    class="btn-line-red">立即查看</a>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>

        <page-footer></page-footer>
    </div>
</template>
<script>
import forexMenu from '../../components/forex-menu/forex-menu.vue';


export default {
    components: {
        forexMenu
    },
    mounted() {
       // 获取所有的QA-item元素
            var qaItems = document.querySelectorAll(".QA-item");

            // 遍历每个QA-item，为其添加点击事件监听器
            qaItems.forEach(function (item) {
                item.addEventListener("click", function () {
                    // 获取当前点击的QA-content元素
                    var content = this.querySelector(".QA-content");

                    // 如果点击的QA-content是隐藏的，则展示它；反之则隐藏
                    if (content.style.display === "none" || content.style.display === "") {
                        // 移除所有其他QA-item上的.QA-actived类，并隐藏其QA-content
                        qaItems.forEach(function (otherItem) {
                            otherItem.querySelector(".QA-content").style.display = "none";
                            otherItem.classList.remove("QA-actived");
                        });

                        // 展示当前点击的QA-content，并为当前QA-item添加.QA-actived类
                        content.style.display = "block";
                        this.classList.add("QA-actived");
                    } else {
                        // 如果已经是显示状态，则隐藏并移除.QA-actived类
                        content.style.display = "none";
                        this.classList.remove("QA-actived");
                    }
                });
            });
        

    }
}
</script>

<style>
    body{
        font-family: "Inter", "Noto Sans", "Noto Sans SC", sans-serif !important;
    }
</style>
<style scoped>
@import url("../../assets/css/forex/rem.css");
@import url("../../assets/css/forex/common.css");
@import url("../../assets/css/forex/forex-tool.css");

.forex-index {
    font-family: "Inter", "Noto Sans", "Noto Sans SC", sans-serif !important;
}
</style>